import { fromJS } from 'immutable'

export default fromJS({
  questions: {
    noAlt: 'Tämän kuvan vaihtoehtoinen teksti puuttuu',
    noAnswers: 'Ei vastausvaihtoehtoa, jatka napsauttamalla Seuraava...',
    placeholder: 'Tarkenna...',
    pleaseSelect: 'Valitse...',
    rotateLandscape: 'Poista näytön lukitus käytöstä puhelimessasi ja käännä se vaaka-asentoon jatkaaksesi.',
    rotatePortrait: 'Käännä puhelin vaaka-asennosta pystyasentoon jatkaaksesi.',
    ir: {
      selectWebCam: "Valitse web-kamera (jos saatavilla) tai napsauta 'Selaa' ladataksesi kuvan laitteestasi",
      uploadOnly: 'Napsauta Selaa ladataksesi kuvan laitteestasi',
      noWebCam: 'Web-kameraa ei havaittu',
      accessCamUpload: 'AVAA KAMERA/LATAA',
      browse: 'SELAA',
      uploadPhoto: 'Lataa valokuva',
      camera: 'Web-kamera',
      instead: 'sen sijaan',
      capture: 'TALLENNA',
      somethingWrong: 'Pahoittelut, jotain meni pieleen. Yritä uudelleen.',
      couldntRead: 'Valitettavasti emme voineet lukea koodia!',
      couldntProcess: 'Valitettavasti emme voineet käsitellä kuvaasi!',
      inValidCode: 'Ole hyvä ja lähetä kelvollinen koodi',
      moveOn: 'Yritä uudelleen tai lähetä valokuvasi ja siirry eteenpäin',
      tryAgain: 'Yritä uudelleen',
      dataReceived: 'Tiedot vastaanotettu!',
      enterManually: 'Yritä uudelleen tai syötä tiedot manuaalisesti alle',
      positionQR:
        'Aseta QR-koodi kamerasi eteen niin, että se istuu punaiseen kehykseen, tai lataa se tietokoneeltasi.',
      uploadQR: 'Lataa QR-koodi tietokoneeltasi',
      uploadQRMobile: 'Lataa QR-koodi laitteeltasi.',
      positionQRMobile:
        'Aseta QR-koodi kamerasi eteen niin, että se istuu punaiseen kehykseen, tai lataa se tietokoneeltasi.',
      analyzing: 'Analysoidaan kuvaa, odota',
      submit: 'LÄHETÄ',
      startOver: 'Aloitta alusta',
      allDone: 'Valmis!',
      cantAnalyze:
        'Huomio – emme voineet renderoida tätä kuvaa. Yritä lähettää se uudelleen tai valitse yleisempi kuvamuoto (JPG, PNG, GIF, BMP)',
      wrongFormat:
        'Valitettavasti emme tue tätä tiedostomuotoa. Lataa tuettu kuvatyyppi (JPG, PNG, GIF, BMP, TIF, PDF, SVG)'
    },
    vr: {
      noWebCam: 'Web-kameraa ei havaittu',
      uploadVideo: 'Lataa video',
      skip: 'Ohita?',
      accessCamUpload: 'AVAA KAMERA/LATAA',
      browse: 'SELAA',
      instead: 'sen sijaan',
      or: 'tai',
      stopRecording: 'Lopeta tallennus',
      willBeStopped: 'Tallennus pysähtyy <b>5 minuutin</b> kohdalla',
      stopOnDone: 'Lopeta tallennus, kun olet valmis! ',
      record: 'TALLENNA',
      somethingWrong: 'Pahoittelut, jotain meni pieleen. Yritä uudelleen.',
      dataReceived: 'Tiedot vastaanotettu!',
      microphone: 'Valitse mikrofonisi',
      camera: 'Valitse web-kamerasi',
      selectMicrophone: 'Valitse mikrofonisi',
      selectCam: 'Valitse web-kamerasi',
      submit: 'LÄHETÄ',
      upload: 'LATAA',
      playback: 'Toisto',
      stopPlayback: 'PYSÄYTÄ TOISTO',
      startOver: 'Aloitta alusta',
      allDone: 'Valmis!',
      alternativeRecordSpan: 'Ole hyvä ja lataa videoleike tietokonelaitteeltasi. <br/>Vaihtoehtoisesti voit &nbsp;',
      alrenativeRecordHref: 'tallentaa videon web-kameralla.',
      cantAnalyze:
        'Huomio – emme voineet renderoida tätä kuvaa. Yritä lähettää se uudelleen tai valitse yleisempi kuvamuoto (JPG, PNG, GIF, BMP)',
      wrongFormat:
        'Valitettavasti emme tue tätä tiedostomuotoa. Lataa tuettu kuvatyyppi (JPG, PNG, GIF, BMP, TIF, PDF, SVG)'
    },
    cjc: {
      choose: 'VALITSE',
      pleaseChoose: 'Valitse',
      this: 'TÄMÄ',
      one: 'yksi',
      myChoice: 'MINUN VALINTANI'
    },
    hm: {
      addComment: 'Lisää kommentti alle',
      commentMandatoryPlaceHolder: 'Lisää pakollinen kommentti... ',
      commentOptionalPlaceHolder: 'Lisää valinnainen kommentti... ',
      dragPin: 'Vedä sijoittaaksesi uudelleen (pitkä klikkaus/napautus tarkkuutta varten).',
      removePin: 'Vedä kuvan ulkopuolelle poistaaksesi.',
      editComment: 'Klikkaa/napauta merkkiä muokataksesi kommenttia.',
      addPin: 'Vedä merkki alla olevasta paneelista ja pudota se haluamaasi kohtaan kuvassa.',
      addPins: 'Vedä merkit alla olevasta paneelista ja pudota ne haluamaasi kohtaan kuvassa.',
      leavePins: (minPoints, maxPoints) =>
        `Jätä vähintään ${minPoints} mutta enintään ${maxPoints} minkälaista merkkiä tahansa.`,
      leavePinsAny: (minPoints, maxPoints) =>
        `Jätä vähintään ${minPoints} mutta enintään ${maxPoints} minkälaista merkkiä tahansa.`,
      leavePinsPerPage: (minPoints, maxPoints) =>
        `Jätä vähintään ${minPoints} mutta enintään ${maxPoints} minkälaista merkkiä tahansa.`,
      leavePinsWithOff: maxPoints =>
        `Jätä korkeintaan ${maxPoints} minkälaista tahansa merkkiä tai napsauta Seuraava ohittaaksesi.`,
      leavePinsWithOffAny: maxPoints =>
        `Jätä korkeintaan ${maxPoints} minkälaista tahansa merkkiä tai napsauta Seuraava ohittaaksesi.`,
      leavePinsPerPageWithOff: maxPoints => `Jätä korkeintaan ${maxPoints} merkkiä tai napsauta Seuraava ohittaaksesi.`,
      leavePinWithOff: `Jätä korkeintaan 1 minkälainen tahansa merkki tai napsauta Seuraava ohittaaksesi.`,
      leavePinWithOffAny: `Jätä korkeintaan 1 minkälainen tahansa laista merkkiä tai napsauta Seuraava ohittaaksesi.`,
      leavePinPerPageWithOff: 'Jätä korkeintaan 1 merkkiä tai napsauta Seuraava ohittaaksesi..',
      leaveExactlyPin: `Jätä 1 minkälaista tahansa merkkiä.`,
      leaveExactlyPinAny: `Jätä 1 minkälainen tahansa merkki.`,
      leaveExactlyPinPerPage: 'Jätä 1 merkki.',
      leaveExactlyPins: maxPoints => `Jätä ${maxPoints} minkälaista tahansa merkkiä. `,
      leaveExactlyPinsAny: maxPoints => `Jätä ${maxPoints} minkälaista tahansa merkkiä. `,
      leaveExactlyPinsPerPage: maxPoints => `Jätä ${maxPoints} merkkiä.`,
      leaveComment: 'Kirjoita kuvan alle jättääksesi kommentin.',
      noAnswers: 'Ei vastausvaihtoehtoa, jatka napsauttamalla Seuraava.',
      outOfPins: 'Merkkisi ovat loppu',
      pinsBehavior: 'Kun liikut kuvan poikki, näet alueita, jotka korostetaan yhdellä merkin pudotuksella.',
      clusters: 'Voit asettaa merkkejä vain näille korostetuille alueille.',
      contentAware: 'Voit pudottaa merkkejä korostettujen alueiden sisään tai ulkopuolelle.'
    },
    mp: {
      expand_note: 'Laajenna viemällä hiiren osoitin kuvien päälle tai napsauttamalla niitä',
      rb_note: rows => `Valitse${rows ? ' alta' : ''} vain 1 vastaus per kohde:`,
      cb_note: (min, max, rows) => {
        if (min === max) {
          return `Valitse ${rows ? 'alta' : ''} ${min !== 1 ? 'mikä tahansa' : 'vain'} ${min} vastaus${
            min !== 1 ? 'ta' : ''
          } per kohde:`
        } else if (min > 0 && max < 5000) {
          return `Valitse vähintään ${min} vastaus${min !== 1 ? 'ta' : ''} mutta enintään ${max} vastausta ${
            rows ? 'alla' : ''
          } oleviin kohtiin:`
        } else if (5000 === max && min > 0) {
          return `Valitse vähintään ${min} vastaus${min !== 1 ? 'ta' : ''}${rows ? 'alla' : ''} oleviin kohtiin:`
        } else if (0 === min && max < 5000) {
          return `Valitse enintään ${max} vastaus${max !== 1 ? 'ta' : ''}${rows ? 'alla' : ''} oleviin kohtiin:`
        } else {
          return 'Valitse kaikki sopivat:'
        }
      }
    },
    sh: {
      note: 'Napsauta tuotetta zoomataksesi ja lisätäksesi sen virtuaalikoriisi, jos ostaisit sen kaupasta',
      amazonNote: 'Napsauta tuotetta zoomataksesi ja lisätäksesi sen virtuaalikoriisi',
      fullCart: 'Ostoskorisi on täynnä!',
      qty: 'KPL',
      each: 'jokainen',
      items: 'kohteita',
      addToCart: 'LISÄÄ OSTOSKORIIN',
      deleteFromCart: 'POISTA',
      emptyCard: 'Ostoskorisi on tyhjä',
      total: 'Ostoskori',
      clearCart: 'Tyhjennä ostoskori',
      backToStore: 'Takaisin kauppaan',
      na: 'Ei mikään ylläolevista',
      scrollError: `Ole hyvä ja vieritä kokonaan vasemmalle ja oikealle jatkaaksesi kyselyssä. `,
      next: 'SEURAAVA'
    },
    rb: {
      note: 'Valitse vain 1 kohde:'
    },
    vo: {
      note: 'Katso video loppuun asti'
    },
    cb: {
      note: (min, max) => {
        if (1 === min && 5000 === max) {
          return 'Valitse kaikki sopivat:'
        } else if (min === max) {
          return `Valitse ${min !== 1 ? 'mikä tahansa' : 'vain'} ${min} kohde${min !== 1 ? 'tta' : ''}:`
        } else if (min > 0 && max < 5000) {
          return `Valitse vähintään ${min} kohde${min !== 1 ? 'tta' : ''} mutta enintään ${max} riviä kohden:`
        } else if (5000 === max && min > 0) {
          return `Valitse vähintään ${min} kohde${min !== 1 ? 'tta' : ''}`
        } else if (0 === min && max < 5000) {
          return `Valitse enintään  ${max} kohde${max !== 1 ? 'tta' : ''}:`
        } else {
          return 'Valitse kaikki sopivat:'
        }
      }
    },
    oe: {
      na: 'Ei sovellettavissa',
      note: (min, max, optional) => {
        if (min === max) {
          return `Kirjoita ${1 !== min ? 'mikä tahansa' : 'tasan'} ${min} merkki${1 !== min ? 'ä' : ''}${
            optional ? ' (valinnainen)' : ''
          }:`
        } else if (min > 0 && max < 5000) {
          return `Kirjoita vähintään ${min} merkki${1 !== min ? 's' : ''} mutta enintään ${max}${
            optional ? ' (valinnainen)' : ''
          }:`
        } else if (5000 === max && min > 0) {
          return `Kirjoita vähintään ${min} merkki${1 !== min ? 'ä' : ''}${optional ? ' (valinnainen)' : ''}:`
        } else if (0 === min && max < 5000) {
          return `Kirjoita enintään ${max} merkki${1 !== min ? 'ä' : ''}${optional ? ' (valinnainen)' : ''}:`
        } else {
          return ''
        }
      }
    },
    oex: {
      note: 'Täytä seuraavat kentät:'
    },
    mx: {
      note: 'Jatka siirtämällä korostettuja liukusäätimiä',
      dragSlider: 'Vastaa vetämällä vasemmalle tai oikealle'
    },
    psc: {
      dragLeftRight: 'Vastaa vetämällä vasemmalle tai oikealle'
    },
    ps: {
      note: (value, remaining) => `Jaa ${remaining ? 'loput' : ''} ${value} alla olevien kohteiden kesken`,
      allDone: `Valmis`,
      total: `kaikki yhteensä:`,
      dragSlider: 'Vastaa vetämällä vasemmalle tai oikealle'
    },
    cx: {
      note: 'Avaa pudotusvalikko ja ala kirjoittaa vastausta automaattista selausta varten tai valitse se manuaalisesti'
    },
    ro: {
      note: 'Järjestä uudelleen vetämällä ylös tai alas:'
    },
    md: {
      note1: 'Napsauta/napauta ensimmäistä valitsemaasi kohdetta. <br/> Napsauta uudelleen poistaaksesi valinnan.',
      note2: 'Napsauta/napauta nyt viimeistä valitsemaasi kohdetta. <br/>Napsauta uudelleen poistaaksesi valinnan.',
      note3:
        'Kiitos! Jatka seuraavaan kysymykseen<br/>tai napsauta/napauta mitä tahansa valitsematonta kohdetta aloittaaksesi alusta.'
    },
    aro: {
      note: 'Valitse yksi kohde jokaisesta parista:'
    },
    wd: {
      note: 'Varmista, että jokainen seuraava arvo on suurempi kuin edellinen.'
    },
    emd: {
      note: 'Katso video loppuun asti\n',
      noAnswers: 'Ei vastausvaihtoehtoa, jatka napsauttamalla Seuraava.',
      start: 'Napsauta ja pidä painettuna aloittaaksesi',
      resume: 'Napsauta ja pidä painettuna jatkaaksesi',
      continue: 'Olet valmis! <br />Napsauta <strong>SEURAAVA</strong> jatkaaksesi',
      continueMobile: 'Olet valmis!<br />Napsauta <strong>TÄSTÄ</strong> jatkaaksesi',
      training: {
        session: 'Koulutussessio',
        note: 'Lopeta koulutus',
        moveLeft: 'Vedä valitsin kokonaan <strong>vasemmalle</strong>',
        moveBottom: 'Vedä valitsin kokonaan <strong>alhaalle</strong>',
        moveRight: 'Nyt, ole hyvä ja Vedä valitsin kokonaan <strong>oikealle</strong>',
        moveTop: 'Nyt, ole hyvä ja Vedä valitsin kokonaan <strong>ylhäälle</strong>',
        success: 'Hyvää työtä!'
      }
    },
    sft: {
      noAnswers: 'Ei vastausvaihtoehtoa, jatka napsauttamalla Seuraava.',
      note: 'Vastaa mahdollisimman nopeasti intuitiivisesti oikealta tuntuvalla vastauksella',
      finish: 'Olet valmis! <br /> Jatka napsauttamalla Seuraava.',
      training: {
        start:
          '<p>Tämä kysymys näyttää sinulle nopeasti erilaisia sanoja ja vaatii keskittymistäsi. ' +
          'Sinun on reagoitava nopeasti vastataksesi. </p> <p>Oletko valmis harjoittelemaan?</p>',
        step1: (touch, mouse, key) =>
          touch
            ? `Napauta "{buttonLeft}"`
            : (mouse ? `Napsauta "{buttonLeft}"` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `Paina "{keyBtnLeft}" näppäintä` : ''),
        step2: (touch, mouse, key) =>
          touch
            ? `Napauta "{buttonRight}"`
            : (mouse ? `Napsauta "{buttonRight}"` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `Paina "{keyBtnRight}" näppäintä` : ''),
        fail: () => 'Liian hidas',
        success: () => 'Mahtavaa!',
        finish: () =>
          '<p><strong> Erinomaista!</strong></p><p>Varmista, että sinua<br />' +
          'ei häiritä seuraavien<br/> 2–3 minuutin aikana</p><p>Kun olet valmis, napsauta Seuraava aloittaaksesi.</p>'
      },
      buttons: {
        start: 'Aloita',
        yesno: {
          left: 'Kyllä',
          right: 'Ei'
        },
        matches: {
          left: 'Osuma',
          right: 'Ei osumaa'
        },
        fits: {
          left: 'Sopiva',
          right: 'Ei sopiva'
        },
        thumbs: {
          left: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsUp"></i>',
          right: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsDown"></i>'
        },
        noyes: {
          left: 'Kyllä',
          right: 'Ei'
        },
        matchesRev: {
          left: 'Osuma',
          right: 'Ei osumaa'
        },
        fitsRev: {
          left: 'Sopiva',
          right: 'Ei sopiva'
        },
        thumbsRev: {
          left: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsUp"></i>',
          right: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsDown"></i>'
        }
      }
    }
  }
})
